class Cl {
    constructor() {
    }

    addEvent(parent, evt, selector, handler) {
        parent.addEventListener(evt, function (event) {
            if (event.target.matches(selector + ', ' + selector + ' *')) {
                handler.apply(event.target.closest(selector), arguments);
            }
        }, false);
    }

    hide(elems) {
        elems.forEach(box => { box.style.display = 'none' })
    }

    show(elems) {
        elems.forEach(box => { box.style.display = 'block' })
    }

    first(inputs, closure) {
        let needle = null;
        inputs.forEach((el) => {
            if (closure(el)) {
                needle =  el;
            }
        })
        return needle;
    }

    /**
     * @param element
     * @param delay
     * @param animation (ease, linear, ease-in, ease-out, ease-in-out, cubic-bezier(x1, y1, x2, y2)
     */
    fadeIn(element, delay = 200, animation = 'ease') {
        element.style.display = 'block';
        element.style.opacity = '0'
        element.style.transition = `opacity ${delay} ${animation}`
        setTimeout(function () {
            element.style.opacity = '1'
        }, 0);
    }

    /**
     * @param element
     * @param delay
     * @param animation (ease, linear, ease-in, ease-out, ease-in-out, cubic-bezier(x1, y1, x2, y2)
     */
    fadeOut(element, delay = 200, animation = 'ease') {
        element.style.transition = `opacity ${delay} ${animation}`
        setTimeout(function () {
            element.style.opacity = '0'
        }, 0);
        element.addEventListener('transitionend', function () {
            element.style.display = 'none';
        }, {
            once: true
        });
    }

    headers() {
        return {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
        }
    }
}

export default Cl
